"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
var urlcat_1 = __importDefault(require("urlcat"));
function route(path) {
    return function (params, basePath) { return "" + (basePath !== null && basePath !== void 0 ? basePath : '') + urlcat_1.default(path, params !== null && params !== void 0 ? params : {}); };
}
function makeRoute(path) {
    return {
        path: path,
        getUrl: route(path),
    };
}
exports.routes = {
    accountEnrichedLinesOfCoverage: makeRoute('/line-of-coverage-from-account/:accountUuid'),
    accountPolicies: makeRoute('/policies-from-account/:accountUuid'),
    createScheduledItems: makeRoute('/scheduled-item/create'),
    updateScheduledItem: makeRoute('/scheduled-item/:scheduledItemUuid/update'),
    deleteScheduledItem: makeRoute('/scheduled-item/:scheduledItemUuid/delete'),
    definitions: makeRoute('/definitions'),
    enrichedScheduledItemByUuid: makeRoute('/scheduled-item/enriched/:scheduledItemUuid'),
    createInsurableItem: makeRoute('/insurable-items/create'),
    insurableItemByUuid: makeRoute('/insurable-items/:insurableItemUuid'),
    updateInsurableItem: makeRoute('/insurable-items/:insurableItemUuid/update'),
    updateInsurableItemDisplayName: makeRoute('/insurable-items/:insurableItemUuid/update-display-name'),
    archiveInsurableItem: makeRoute('/insurable-items/:insurableItemUuid/archive'),
    unarchiveInsurableItem: makeRoute('/insurable-items/:insurableItemUuid/activate'),
    insurableItemMetadata: makeRoute('/insurable-item-metadata/:insurableItemType'),
    insurableItemTypeDefinitions: makeRoute('/insurable-item-type-definitions'),
    insurableItemsByAccount: makeRoute('/insurable-items-from-account/:accountUuid'),
    linesOfCoverageMetadata: makeRoute('/line-of-coverage-metadata/:lineOfCoverageType'),
    policyByUuid: makeRoute('/policies/:policyUuid'),
    createHistoricalPolicy: makeRoute('/create-historical-policy'),
    renewPolicyAsIs: makeRoute('/renew-policy-as-is'),
    policyEnrichedLinesOfCoverage: makeRoute('/line-of-coverage-from-policy/:policyUuid'),
    unlink: makeRoute('/scheduled-items/:scheduledItemUuid/unlink'),
    updatePolicyLinesOfCoverage: makeRoute('/policies/:policyUuid/lines-of-coverage'),
    updatePolicyNotes: makeRoute('/policies/:policyUuid/notes'),
    updatePolicyBilling: makeRoute('/policies/:policyUuid/billing'),
    updatePolicyDetails: makeRoute('/policies/:policyUuid/details'),
    updatePolicyDateRange: makeRoute('/policies/:policyUuid/date-range'),
    scheduledItemsByInsurableItem: makeRoute('/insurable-items/:insurableItemUuid/scheduled-items'),
};
